import React, { useState, useEffect, useRef } from "react";
import { Link } from "@quintype/components";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import { AccessType } from "@quintype/components";
import { requestAccessTypeDhToken } from "../subscription-page/auth-client.js";
import { AutoModal } from "../subscribe-page/auto-modal/index.js";
import { AutoRenewelModal } from "../subscribe-page/autorenewel-modal/index.js";
import "./my-subscription.m.css";
import { SpinnerLoader } from "../../common/loader/index.js";
import { setLoading } from "../../../components/store/actions";
import Whatsapp from "../../atoms/social-media-icons/Whatsapp";
import Mail from "../../atoms/social-media-icons/Mail";

const RedCheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="12" fill="#FF0000" fillOpacity="0.15" />
    <mask id="mask0_2841_12334" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="3" y="3" width="18" height="18">
      <rect x="3" y="3" width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2841_12334)">
      <path d="M9.3 15.7498L8.25 14.6998L10.95 11.9998L8.25 9.31855L9.3 8.26855L12 10.9686L14.6812 8.26855L15.7313 9.31855L13.0312 11.9998L15.7313 14.6998L14.6812 15.7498L12 13.0498L9.3 15.7498Z" fill="#FF0000" />
    </g>
  </svg>
);

const CancelIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7" stroke="#F23D3D" strokeWidth="1.2" />
    <path d="M5.5 5.5L10.5 10.5M10.5 5.5L5.5 10.5" stroke="#F23D3D" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

const TickIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none" style={{ width: '12.225px', height: '9.019px', fill: '#000' }}>
    <path d="M4.275 9.01875L0 4.74375L1.06875 3.675L4.275 6.88125L11.1563 0L12.225 1.06875L4.275 9.01875Z" fill="black" />
  </svg>
);

const CrownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path d="M6.48 10.08H7.92V7.056L9.072 8.208L10.08 7.2L7.2 4.32L4.32 7.2L5.328 8.208L6.48 7.056V10.08ZM7.2 14.4C6.204 14.4 5.268 14.211 4.392 13.833C3.516 13.455 2.754 12.942 2.106 12.294C1.458 11.646 0.945 10.884 0.567 10.008C0.189 9.132 0 8.196 0 7.2C0 6.204 0.189 5.268 0.567 4.392C0.945 3.516 1.458 2.754 2.106 2.106C2.754 1.458 3.516 0.945 4.392 0.567C5.268 0.189 6.204 0 7.2 0C8.196 0 9.132 0.189 10.008 0.567C10.884 0.945 11.646 1.458 12.294 2.106C12.942 2.754 13.455 3.516 13.833 4.392C14.211 5.268 14.4 6.204 14.4 7.2C14.4 8.196 14.211 9.132 13.833 10.008C13.455 10.884 12.942 11.646 12.294 12.294C11.646 12.942 10.884 13.455 10.008 13.833C9.132 14.211 8.196 14.4 7.2 14.4ZM7.2 12.96C8.808 12.96 10.17 12.402 11.286 11.286C12.402 10.17 12.96 8.808 12.96 7.2C12.96 5.592 12.402 4.23 11.286 3.114C10.17 1.998 8.808 1.44 7.2 1.44C5.592 1.44 4.23 1.998 3.114 3.114C1.998 4.23 1.44 5.592 1.44 7.2C1.44 8.808 1.998 10.17 3.114 11.286C4.23 12.402 5.592 12.96 7.2 12.96Z" fill="black" />
  </svg>
);

const useRedirectUrl = () => {
  const [redirectUrl, setRedirectUrl] = useState("");
  useEffect(() => {
    if (typeof window !== "undefined" && document.referrer) {
      try {
        const referrer = new URL(document.referrer);
        if (
          referrer.origin === window.location.origin &&
          !referrer.pathname.includes("/profile") &&
          !referrer.pathname.includes("/subscribe")
        ) {
          setRedirectUrl(referrer.pathname + referrer.search);
        }
      } catch (e) { }
    }
  }, []);
  return redirectUrl;
};

const FreeUserBox = () => {
  const redirectUrl = useRedirectUrl();
  const subscribeHref = `/subscribe?utm_source=dh_site&utm_medium=profile_page&utm_campaign=dh_subscription${redirectUrl ? `&redirect_url=${encodeURIComponent(redirectUrl)}` : ""}`;

  return (
    <div styleName="freeUserBox">
      <div styleName="freeHeaderRow">
        <span styleName="freePlanName">Freemium</span>
        <span styleName="freePlanPrice">₹0</span>
      </div>
      <div styleName="separator"></div>
      <div styleName="missingFeaturesText">
        On your current freemium plan, you're missing out on the following benefits.
      </div>
      <div styleName="featureList">
        <div styleName="featureRow">
          <RedCheckIcon />
          <span styleName="featureText">Access to All Premium Stories</span>
        </div>
        <div styleName="featureRow">
          <RedCheckIcon />
          <span styleName="featureText">Epaper Access</span>
        </div>
        <div styleName="featureRow">
          <RedCheckIcon />
          <span styleName="featureText">Ad-Lite Experience</span>
        </div>
      </div>
      <Link href={subscribeHref} styleName="subscribeCta">
        <CrownIcon />
        <span styleName="subscribeCtaText">Subscribe Now</span>
      </Link>
    </div>
  );
};

const SupportBox = () => {
  return (
    <div styleName="supportBox">
      <div styleName="support-text">Contact us:</div>
      <div styleName="contactsWrapper">
        <div styleName="mailButton">
          <Mail width={16} height={12} color="#999" />
          <span styleName="mailText">support<span></span>@deccanherald.com</span>
        </div>

        <div styleName="whatsappButton">
          <Whatsapp width={18} height={18} color="#25D366" />
          <span styleName="whatsappText">+91 90352<span></span>67305</span>
        </div>
      </div>
    </div>
  );
};



const ActiveUserBox = ({ activeSubscription, email, phone, name, cancelSubscription, onCancelSuccess }) => {
  const [showAutoModal, setShowAutoModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const dispatch = useDispatch();
  const redirectUrl = useRedirectUrl();
  const subscribeHref = `/subscribe?utm_source=dh_site&utm_medium=profile_page&utm_campaign=dh_subscription${redirectUrl ? `&redirect_url=${encodeURIComponent(redirectUrl)}` : ""}`;
  const durationUnit = activeSubscription?.duration_unit || "year";
  const durationLength = activeSubscription?.duration_length || 1;
  const planPrice = activeSubscription?.plan_amount_cents ? (activeSubscription.plan_amount_cents / 100) : 0;
  const currencySymbol = activeSubscription?.plan_amount_currency === "USD" || activeSubscription?.payment_amount_currency === "USD" ? "$" : "₹";
  const isOneTimePlan = activeSubscription?.plan_occurrence === "One Time";



  const englishSuffix = (durationUnit.charAt(0).toUpperCase() + durationUnit.slice(1)).replace(/s$/, "");
  console.log("email", email);
  console.log("phone", phone);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const endDate = activeSubscription?.end_timestamp || activeSubscription?.end_date || null;
  const formattedEndDate = formatDate(endDate);

  const status = activeSubscription?.status?.toLowerCase();
  const isCancelled = status === "cancelled" || status === "expired" || activeSubscription?.cancelled === true;

  const handleCancel = async (reason) => {
    setShowAutoModal(false);
    setIsCancelling(true);
    dispatch(setLoading(true));
    try {
      const subscriptionId = activeSubscription?.id;

      if (typeof cancelSubscription === "function") {
        await cancelSubscription(subscriptionId);
      }

      const response = await fetch("/plan-cancel-request", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, phone, currentPlan: activeSubscription, reason, subscriptionId, name })
      });
      const data = await response.json();
      
      if (data.success) {
        setShowSuccessModal(true);

        if (window) {
          const { getAuthStatus } = require("../../helper/datalayer-utils");
          const { uuid } = getAuthStatus();

          let planName = `${durationLength}-${durationUnit.toLowerCase().replace(/s$/, "")}`;
          if (planName === "1-month") planName = "monthly";

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "renewal_cancellation",
            uuid: uuid,
            plan_name: planName,
            plan_price: activeSubscription?.plan_amount_cents ? activeSubscription.plan_amount_cents / 100 : "NA"
          });
        }

        if (typeof onCancelSuccess === "function") {
          onCancelSuccess();
        }
      }
    } catch (e) {
      console.error("[ActiveUserBox] Plan cancel request failed:", e);
    } finally {
      setIsCancelling(false);
      dispatch(setLoading(false));
    }
  };

  return (
    <div styleName="activeUserBox">
      {isCancelling && (
        <div styleName="overlayLoader">
          <SpinnerLoader />
        </div>
      )}
      <div styleName="headerRow">
        <span styleName="planName">{activeSubscription?.plan_name || `${durationLength} ${englishSuffix} Plan`}</span>
        <span styleName="planPrice">{currencySymbol}{planPrice}/{englishSuffix}</span>
      </div>

      <div styleName="renewalDate">
        {isCancelled || isOneTimePlan ? `Expires on ${formattedEndDate}` : `Next Renewal on ${formattedEndDate}`}
      </div>

      {isCancelled || isOneTimePlan ? (
        <div styleName="cancelledCtaRow">
          <Link href={subscribeHref} styleName="cancelledCta">
            <TickIcon />
            <span styleName="cancelledCtaText">See All Plans</span>
          </Link>
        </div>
      ) : (
        <div styleName="ctaRow">
          <button type="button" styleName="cancelCta" onClick={() => setShowAutoModal(true)}>
            <CancelIcon />
            <span styleName="cancelCtaText">Cancel Renewal</span>
          </button>
          <Link href={subscribeHref} styleName="subscribeCtaFlex">
            <CrownIcon />
            <span styleName="subscribeCtaText">Upgrade plan</span>
          </Link>
        </div>
      )}
      {showAutoModal && <AutoModal onClose={() => setShowAutoModal(false)} onCancelClick={handleCancel} />}
      {showSuccessModal && <AutoRenewelModal onClose={() => {
        setShowSuccessModal(false);
      }} expiryDate={formattedEndDate} />}
    </div>
  );
};

const MySubscriptionInner = ({ initAccessType, getSubscriptionForUser, cancelSubscription }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [activeSubscription, setActiveSubscription] = useState(null);
  const isInit = useRef(false);
  const userdetails = useSelector((state) => get(state, ["user", "user"], {}));
  const qt = useSelector((state) => get(state, ["qt"], {}));
  const ssoEndpoint = get(qt, ["config", "publisher-attributes", "sso_endpoint"], "");

  const email = userdetails?.userData?.emails?.[0] || userdetails?.email;
  const phone = userdetails?.userData?.phone || userdetails?.phone || userdetails?.phoneNumbers?.[0] || userdetails?.mobile || userdetails?.userData?.phoneNumbers?.[0];
  const name = userdetails?.metadata?.first_name || userdetails?.name || "";
  console.log("MySubscriptionInner email", email);
  console.log("MySubscriptionInner phone", phone);
  console.log("MySubscriptionInner userdetails", userdetails);
  const ensureAT = async () => {
    if (window.AccessType?.setUser) return true;
    return new Promise(r => {
      let a = 0;
      const c = setInterval(() => {
        if (window.AccessType?.setUser || ++a > 100) {
          clearInterval(c);
          r(!!window.AccessType?.setUser);
        }
      }, 100);
      if (!isInit.current) {
        isInit.current = true;
        initAccessType(() => {
          if (window.AccessType?.setUser) {
            clearInterval(c);
            r(true);
          }
        });
      }
    });
  };

  const syncUser = async () => {
    const isReady = await ensureAT();
    if (!isReady) return;

    let token;

    try {
      token = await requestAccessTypeDhToken("");
    } catch (e) {
      console.error("[MySubscriptionInner] Failed to get AccessType token:", e);
      return;
    }

    try {
      await window.AccessType.setUser({ emailAddress: email, mobileNumber: phone, accesstypeJwt: token });
    } catch (e) {
      console.error("[MySubscriptionInner] window.AccessType.setUser failed:", e);
    }
  };

  useEffect(() => {
    let isMounted = true;
    const loadUserSubscriptions = async () => {
      try {
        await syncUser();
        const subs = await getSubscriptionForUser();
        let sList = Array.isArray(subs) ? subs : (subs?.subscriptions || []);

        if (isMounted) {
          let active = sList.find(s => (s.status === "active" || s.status === "ACTIVE" || s.status === "Active") && s.active !== false);

          if (!active) {
            active = sList.find(s => {
              const st = s.status?.toLowerCase();
              return st === "cancelled" && s.active !== false;
            });
          }

          if (active) {
            setActiveSubscription(active);
          }
          setIsLoading(false);
        }
      } catch (err) {
        if (isMounted) {
          console.error("[MySubscriptionInner] Error loading user subscriptions:", err);
          setIsLoading(false);
        }
      }
    };
    loadUserSubscriptions();
    return () => { isMounted = false; };
  }, []);

  if (isLoading) {
    return <SpinnerLoader />
  }

  return (
    <div styleName="subscriptionWrapper">
      {activeSubscription ? (
        <ActiveUserBox activeSubscription={activeSubscription} email={email} phone={phone} name={name} cancelSubscription={cancelSubscription} onCancelSuccess={() => setActiveSubscription({ ...activeSubscription, cancelled: true })} />
      ) : (
        <FreeUserBox />
      )}
      <SupportBox />
    </div>
  );
};

function MySubscription() {
  const qt = useSelector((state) => get(state, ["qt"], {}));
  const userdetails = useSelector((state) => get(state, ["user", "user"], {}));

  const email = userdetails?.userData?.emails?.[0] || userdetails?.email;
  const phone = userdetails?.userData?.phoneNumbers?.[0] || userdetails?.phone;
  const ck = get(qt, ["config", "publisher-attributes", "subscription_setup"], {});
  const aKey = ck.accesstype_key || get(qt, ["config", "publisher-attributes", "accesstype_key"], "");

  if (!aKey) {
    return <div>AccessType Key not configured</div>;
  }

  return (
    <div styleName="subscriptionContainer">
      <AccessType
        accessTypeKey={aKey}
        accessTypeBkIntegrationId={ck.accesstype_subauth || ""}
        enableAccesstype={true}
        email={email}
        phone={phone}
      >
        {accessTypeProps => <MySubscriptionInner {...accessTypeProps} />}
      </AccessType>
    </div>
  );
}

export default MySubscription;
